import WIDGETS from './widgets';

export default {
	name: 'articles_overview',
	spacing: 2,
	widgets: [{ content: WIDGETS.ARTICLES_MAIN, breakpoints: { xs: 12 } }],
};